import script from "./ProxyContent.vue?vue&type=script&setup=true&lang=js"
export * from "./ProxyContent.vue?vue&type=script&setup=true&lang=js"

import "./ProxyContent.vue?vue&type=style&index=0&id=216e8254&scoped=true&lang=css"

import exportComponent from "../../../../../../../var/local/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-216e8254"]])

export default __exports__